<template>
    <header class="header">
        <div class="container">
            <div class="row align-items-center">
                <div
                    class="col-12 col-lg-6 d-flex align-items-center justify-content-between"
                >
                    <div class="header__logo">
                        <img src="/images/promo/logo.svg" alt="" />
                    </div>
                    <div class="header__info">
                        <span class="mt-1 mt-md-0">{{
                            $t("promo.Header - Available until")
                        }}</span>
                        <strong>{{ $t("promo.Header - phone") }}</strong>
                    </div>
                </div>
                <div class="col-6"></div>
            </div>
        </div>
    </header>
</template>

<style lang="scss" scoped>
.header {
    padding: 36px 0;
    &.quote {
        @media (min-width: 1024px) {
            display: none;
        }
    }
    @media (max-width: 1024px) {
        padding: 15px 0;
    }
    @media (max-width: 700px) {
        padding: 12px 0;
    }
    &__logo {
        height: 30px;
        @media (max-width: 700px) {
            height: 25px;
        }
        img {
            height: 100%;
        }
    }
    &__info {
        @media (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
        }
        span {
            font-family: Poppins;
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            color: #959bb5;
            @media (max-width: 1024px) {
                display: block;
                order: 2;
                line-height: 1;
                font-weight: normal;
                font-size: 12px;
                color: #959bb5;
            }
        }
        strong {
            font-weight: 600;
            font-size: 18px;
            color: #12122f;
            margin-left: 8px;
            @media (max-width: 1024px) {
                display: block;
                order: 1;
                line-height: 1;
                font-size: 16px;
                color: #12122f;
                margin: 0;
            }
        }
    }
}
</style>
